import { FormControl } from '@angular/forms';
import { Bot } from '@core/bots';

export interface GetBotInfoReq {
  botId: number;
}

export type UpdateBotInfoReq = Omit<
  Bot,
  | 'updatedAt'
  | 'createdAt'
  | 'image'
  | 'additionalLocales'
  | 'defaultLocale'
  | 'isActive'
  | 'lockedByTask'
> & {
  additionalLocales: number[];
  defaultLocale: number;
};

export interface BotSettingsForm {
  type: FormControl<string>;
  license: FormControl<string>;
  name: FormControl<string>;
  defaultLocale: FormControl<number | undefined>;
  additionalLocales: FormControl<number[]>;
  timezone: FormControl<string>;
}

export enum TaskState {
  SUCCESS = 'SUCCESS',
  STARTED = 'STARTED',
  RETRY = 'RETRY',
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
  REVOKED = 'REVOKED',
  RECEIVED = 'RECEIVED',
}

export interface Task {
  id: string;
  state: TaskState;
  progress: number;
}
